import React from "react";
import * as Sentry from "@sentry/browser";
import Button from "common/components/CustomButtons/Button.jsx";
import ErrorBox from "./ErrorBox";
import store from "store";
//Code copied from ReactJS docs

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    this.state = { eventId: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV === "production") {
      Sentry.withScope(scope => {
        const ss = store.getState();
        if ("user" in ss.services.ids) {
          scope.setUser({ id: ss.services.ids.user });
        }

        scope.setExtras(info);
        const eventId = Sentry.captureException(error);
        this.setState({ eventId });
      });
    } else {
      console.log(error, info);
    }
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI

      return (
        <ErrorBox reload={true}>
          {process.env.NODE_ENV === "production" ? (
            <Button
              key="sentryformbutton"
              fullWidth
              onClick={() => {
                Sentry.showReportDialog({ eventId: this.state.eventId });
              }}
              color="primaryLightBlue"
            >
              Send us a feedback
            </Button>
          ) : null}
        </ErrorBox>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
